import styled from 'styled-components/macro'
import PropTypes from 'prop-types'

export const ModalTitle = styled.p`
  font-size: 1.5rem;
  margin-bottom: 0;
`

export const ModalHeaderContainer = styled.div`
  display: flex;
  width: 100%;
`
ModalHeaderContainer.propTypes = {
  tag: PropTypes.any
}
